import { Component, OnInit, Inject, ViewChild } from '@angular/core';
import { IDialogSearchParams, ICheckListBoardOptions } from '@interfaces';
import { MatDialogRef, MAT_DIALOG_DATA, MatSelectionListChange } from '@angular/material';
import { Subject } from 'rxjs';
import { SearchService } from './dialog-search.service';
import { ROLES, COMPANY, MODULE, UNFILTERED } from '@utils';

@Component({
  selector: 'app-dialog-search',
  templateUrl: './dialog-search.component.html',
  styleUrls: ['./dialog-search.component.sass']
})
export class DialogSearchComponent implements OnInit {
  private _isUser: boolean;
  private _isCompany: boolean;
  private _isModule: boolean;
  private _unfiltered: boolean;

  results: Array<ICheckListBoardOptions>;
  searchTerm$ = new Subject<string>();
  itemsSelected = [];
  searching = false;
  noResults = false;
  bgColor = '#f5f5f5';

  @ViewChild ('items') public items;

  constructor(
    public dialogRef: MatDialogRef<DialogSearchComponent>,
    private searchService: SearchService,
    @Inject(MAT_DIALOG_DATA) public info: IDialogSearchParams
  ) {
    this._isUser = (info.filter === ROLES.ADMIN || info.filter === ROLES.LEADER || info.filter === ROLES.ANALYST
      || info.filter === ROLES.CUSTOMER);
    this._isCompany = (info.filter === COMPANY);
    this._isModule = (info.filter === MODULE);
    this._unfiltered = (info.filter === UNFILTERED);

    this.results = [];

    this.searchService.search(this.searchTerm$, info).subscribe(
      (results: Array<any>) => {
        this.dataAdapter(results);
      },
      err => {
        console.log(err.message);
        this.searching = false;
      }
    );
  }

  ngOnInit() {
    this.items.selectionChange.subscribe((s: MatSelectionListChange) => {
      // this.items.deselectAll();
      // s.option.selected = true;
      const _itemsSelected = s.option.selectionList.selectedOptions.selected.map((item) => item.value);
      this.itemsSelected = _itemsSelected;
    });
  }

  fixVocals(strValue: string) {
    const vocals = [
      {base: 'á', replace: 'a'},
      {base: 'é', replace: 'e'},
      {base: 'í', replace: 'i'},
      {base: 'ó', replace: 'o'},
      {base: 'ú', replace: 'u'},
    ];

    vocals.map(vocal => {
      const fixed = strValue.trim().toLowerCase().replace(/ /g, vocal.replace);
      console.log('fixed', fixed);
    });
  }

  findTermInSource(term: string) {
    const results = [];
    this.info.source.map((item: object) => {
      const strValue: string = item.hasOwnProperty('name') ? item['name'] : undefined;
      // strValue = this.fixVocals(strValue);
      // this.fixVocals(strValue);
      const found = (typeof strValue !== 'undefined') ? strValue.toLowerCase().includes(term) : false;
      // console.log(`${term} ${strValue} ${found}`);
      if (found) {results.push(item); }
    });

    this.dataAdapter(results);
  }

  search(term: string) {
    if (term.trim().length) {
      this.searching = true;
      if (this.info.source.length === 0 && !this.info.onlySource) {
        this.searchTerm$.next(term);
      } else {
        this.findTermInSource(term);
      }
    }
  }

  excludeItem(itemToEvaluate: object) {
    const idToEvaluate: number = parseInt(itemToEvaluate['id'], 10);
    const found = this.info.exclude.findIndex(element => parseInt(element['id'], 10) === idToEvaluate);

    return (found >= 0);
  }

  dataAdapter(dataset: Array<any>) {
    const auxResults: ICheckListBoardOptions[] = [];

    dataset.map(item => {
      if (!this.excludeItem(item)) {
        let _name = '';

        _name = (item.hasOwnProperty('name')) ? item['name'] :
        `${item['first_name']} ${item['last_name']} (${item['email']})`;

        const row: ICheckListBoardOptions = {
          id: item['id'],
          name: _name,
          selected: false,
        };

        auxResults.push(row);
      }
    });

    this.searching = false;
    this.results = auxResults;
    this.noResults = (this.results.length < 1);
  }

  runAssociation(sw: boolean) {
    if (!sw) {
      this.dialogRef.close([]);
    } else {
      this.dialogRef.close(this.itemsSelected);
    }
  }

  swColors(out = false) {
    this.bgColor = (!out) ? '#f5f5f5' : 'white';
  }
}
